export const SOCIALS_ENUM = {
  NEWSFEED_DREAM: "NEWSFEED_DREAM",
  PROFILE_DREAM: "PROFILE_DREAM",
  NEWSFEED_DREAM_ANGEL: "NEWSFEED_DREAM_ANGEL",
  NEWSFEED_CHARITY: "NEWSFEED_CHARITY",
  INTERN_CHARITY: "INTERN_CHARITY",
};
